<template>
  <div class="msg-feedback" ref="feedbackItem">
    <h3 class="feedback-title">请您对本次的服务做出评价：</h3>
    <div class="feedback-ctner">
      <div
        class="choose-item"
        :class="{ selected: selectTag === idx }"
        @click="getScore(item)"
        :key="idx"
        v-for="(item, idx) in scores"
      >
        <div class="choose-item__icon icon_1"></div>
        <div class="choose-item__text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>
<script>
//  import {feedback} from '../assets/js/StaffService';

export default {
  data () {
    return {
      tplId: '',
      selected: -1,
      scores: [
        {
          score: 1,
          text: '非常满意'
        },
        {
          score: 2,
          text: '满意'
        },
        {
          score: 3,
          text: '一般'
        },
        {
          score: 4,
          text: '不满意'
        },
        {
          score: 5,
          text: '很不满意'
        }
      ]
    }
  },
  computed: {
    selectTag () {
      return this.scores.indexOf(this.selected)
    }
  },
  props: ['message'],
  methods: {
    getScore (item) {
      if (this.selectTag > -1) {
        return false
      }
      this.selected = item
      this.$store.dispatch('StaffFeedbackScore', item.score)
    }
  }
}
</script>
<style lang="scss" scoped>
.bubble-type-commit {
  overflow: hidden;
  width: 100%;
  padding: 0;
  margin-bottom: 0;
  border-radius: 10px;
  .feedback-title {
    font-size: 0.16rem;
    color: #10131c;
    margin: 0;
    margin-bottom: 0.12rem;
  }
  .feedback-ctner {
    padding: 0.20rem 0;
    background: #fff;
    border-radius: 0.10rem;
    &:after {
      content: "";
      display: table;
      clear: both;
    }
    .choose-item {
      float: right;
      width: 20%;
      min-width: 4em;
      /*margin-left: .05rem;
        margin-right: .05rem;*/
      text-align: center;
      color: #555;
      text-align: center;
      .choose-item__icon {
        margin: 0 auto 0.16rem auto;
        width: 2em;
        height: 2em;
        background-repeat: no-repeat;
        background-position: center center;
        -webkit-background-size: contain;
        background-size: contain;
        &[class*="icon_"] {
          background-image: url("../../assets/images/score_dft.png");
        }
      }
      .choose-item__text {
        color: #acacac;
        font-size: 85% !important;
      }

      &.selected,
      &.selected ~ .choose-item {
        [class*="icon_"] {
          background-image: url("../../assets/images/score_select.png");
        }
      }
      &.selected .choose-item__text {
        color: #41b6f8;
      }
    }
  }
}
</style>
